import React from 'react';
import { X } from 'lucide-react';

export interface InteractiveModeHUDProps {
  interactionMode: string;
  setInteractionMode: (mode: any) => void;
  setIsCrosshairActive: (val: boolean) => void;
}

export const InteractiveModeHUD: React.FC<InteractiveModeHUDProps> = ({
  interactionMode,
  setInteractionMode,
  setIsCrosshairActive,
}) => {
  if (interactionMode === 'orbit' || interactionMode === 'time') return null;

  return (
    <div className="absolute top-24 md:top-8 left-1/2 transform -translate-x-1/2 z-30 flex justify-center pointer-events-auto transition-all duration-300">
      <div className="bg-[#0a0e27]/90 backdrop-blur-md border border-[#00d9ff]/45 px-4 py-1.5 rounded-full text-center shadow-lg shadow-[#00d9ff]/15 flex items-center justify-center gap-2.5 border-[#00d9ff]/40 shadow-[0_0_15px_rgba(0,217,255,0.15)] animate-in fade-in slide-in-from-top-2 duration-300">
        <p className="text-[10px] md:text-[12px] uppercase font-black leading-none text-[#00d9ff] tracking-[3px]">
          {interactionMode === 'crosshair' ? "CRUZ" : "ZONA"}
        </p>
        <button
          onClick={(e) => {
            e.stopPropagation();
            setInteractionMode('orbit');
            setIsCrosshairActive(false);
          }}
          className="p-1 rounded-full bg-[#ff3d67]/15 text-[#ff3d67] border border-[#ff3d67]/30 hover:bg-[#ff3d67]/25 hover:scale-110 active:scale-95 transition-all cursor-pointer flex items-center justify-center shrink-0"
          title="Sair do Modo"
        >
          <X size={10} className="w-3 h-3" />
        </button>
      </div>
    </div>
  );
};
